import { useState } from "react"
import { auth } from "../firebase/config"
import { createUserWithEmailAndPassword } from "@firebase/auth"
import { useAuthContext } from "../hooks/useAuthContext"
import { useAddToFirebase } from "./useAddToFirebase"
import { useProgramCategories } from "./useProgramCategories"

export const useSignUp = () => {
    const [error, setError] = useState(null)
    const { dispatch } = useAuthContext()
    const { addCompany, addUser, copyMasterAdminProgramToBranch } = useAddToFirebase()
    // const { programCategories } = useProgramCategories('/AdminProgramsTreeMulti/Master')

    const signup = (email, password, adminName, companyName) => {
       setError(null)
       createUserWithEmailAndPassword(auth, email, password)
      .then((res) => {
        addCompany(companyName, email, adminName)
        // add user
        addUser(email, adminName)
        // copy master to branch  
        copyMasterAdminProgramToBranch()
        dispatch({ type: 'LOGIN', payload: res.user })
       })
       .catch((err) => {
        setError(err.message)
       })
    }
     
    return { error, signup }

}